import { Center, LoadingOverlay, Modal, Title } from "@mantine/core";
import type { ReactNode, SetState } from "react";
import { ModalCloseButtonMemo } from "src/component/element";

type CustomModalProps = {
  children: ReactNode;
  isLoading?: boolean;
  onCloseAction?: () => void;
  opened: boolean;
  setOpened: SetState<boolean>;
  title?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
};

export const CustomModal = ({
  children,
  isLoading,
  onCloseAction,
  opened,
  setOpened,
  title,
  size,
}: CustomModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={() => {
        if (onCloseAction) {
          onCloseAction();
        }
        return setOpened(false);
      }}
      centered
      withCloseButton={false}
      padding={0}
      radius={12}
      size={size}
    >
      <ModalCloseButtonMemo
        setOpened={setOpened}
        onCloseAction={onCloseAction}
      />
      {isLoading && <LoadingOverlay visible={isLoading} overlayBlur={2} />}

      {title && (
        <Center mt={32}>
          <Title order={3} fz={16}>
            {title}
          </Title>
        </Center>
      )}
      {children}
    </Modal>
  );
};
